import {
  computed, ref, watch,
} from '@vue/composition-api'

import TrackForm from '@/components/@track/TrackForm'
import TracksTable from './components/TracksTable/TracksTable'
import store from '@/store'

const AVAILABLE_TYPE = ['active', 'carpark', 'rent', 'waiting', 'archive', 'responsible']
const MOBILE_SELECT_ITEMS = ['Активные', 'Автопарк', 'Аренда', 'Заявки', 'Архив', 'Отслеживаемые']
const URL = ['/personal/tracks/active', '/personal/tracks/carpark', '/personal/tracks/rent', '/personal/tracks/waiting', '/personal/tracks/archive', '/personal/tracks/responsible']
export default {
  name: 'index',
  components: {
    TrackForm, TracksTable,
  },
  setup(props, context) {
    const {
      $router, $route, $access, $store,
    } = context.root

    const showDialog = ref(false)
    const state = ref('')
    const role = computed(() => store.getters['auth/companyRole'])
    const pageTitle = computed(() => {
      if (role.value === 'supplier') return 'Управление заказами'
      if (role.value === 'constructor') return 'Управление грузоперевозками'
      return 'Мои треки'
    })
    const showRequestTab = computed(() => role.value !== 'supplier')
    const type = computed(() => {
      if (!$access('tracksClient') && ($route.params.type === 'active' || $route.params.type === 'rent')) return 'carpark'
      if (AVAILABLE_TYPE.includes($route.params.type)) return $route.params.type
      return 'active'
    })
    const isActiveType = computed(() => type.value === 'active' || type.value === 'carpark' || type.value === 'rent')
    const mobileSelectItems = MOBILE_SELECT_ITEMS
    const mobileSelectType = ref(MOBILE_SELECT_ITEMS[AVAILABLE_TYPE.indexOf(type.value)])
    const isUser = computed(() => $store.getters['auth/companyRole'] === 'client')

    const selectType = (val) => {
      $router.push(URL[MOBILE_SELECT_ITEMS.indexOf(val)])
    }

    const setBottomTab = (newType) => {
      state.value = newType
    }

    const handleCreateTrack = () => {
      showDialog.value = false
      selectType()
    }

    const init = () => {
      const { type: routeType } = $route.params
      if (routeType === 'waiting') setBottomTab('owner')
      if (isUser.value) setBottomTab('client')
    }

    watch(() => $route, () => init(), { immediate: true })

    return {
      type,
      state,
      showDialog,
      pageTitle,
      isActiveType,
      mobileSelectItems,
      mobileSelectType,
      showRequestTab,
      isUser,
      selectType,
      setBottomTab,
      handleCreateTrack,
    }
  },
}
